import PropTypes, { bool, number } from 'prop-types';

const { string, arrayOf, shape } = PropTypes;

export const CurrentUserProps = shape({
  id: number,
  chatUserId: number,
  profilePhoto: string,
  name: string,
});

export const MessageProps = shape({
  chatId: number,
  senderId: number,
  recipientId: number,
  schoolId: number,
  groupId: number,
  sentAtInMilli: number,
  readAtInMilli: number,
  sentAtInFormat: string,
  readAtInFormat: string,
  message: string,
  senderName: string,
  recipientName: string,
  type: string,
  uid: string,
  read: bool,
  chatOriginId: number,
  employeeId: number,
  deviceId: number,
});

export const ContactProps = shape({
  id: number,
  chatUserId: number,
  lastUpdateMiliSec: number,
  name: string,
  type: string,
  urlProfilePhoto: string,
  classes: string,
  channels: string,
  filterContent: string,
});

export const ContactsProps = arrayOf(ContactProps);
